<template>
  <div>
    <h2>Plugins</h2>
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li v-for="(p, name) in plugins" :key="name"><a class="nav-link" data-toggle="tab" href="" @click="showPlugin(name)">{{ p.name }}</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" role="tabpanel" id="plugin-seopress-pro">
          <div class="row" v-for="(option, key) in activePlugin.setup" :key="key">
            <div class="col-md-2">{{ option.name }}</div>
            <div class="col-md-10">
              <input type="text" :name="key" v-if="option.type === 'input'" v-model="response[activePlugin.optionName][key]" class="col-lg-8">
              <input type="number" :name="key" v-if="option.type === 'number'" v-model="response[activePlugin.optionName][key]" class="col-lg-8">
              <textarea :name="key" v-if="option.type === 'textarea'" v-model="response[activePlugin.optionName][key]" class="col-lg-8" rows="10" />
              <input type="checkbox" :name="key" v-if="option.type === 'checkbox'" v-model="response[activePlugin.optionName][key]">
              <ul v-if="option.type === 'radio'" class="wp-radio">
                <li v-for="opt in option.values" :key="opt.value">
                  <label :for="'radio-'+key+'-'+opt.value">{{ opt.text || opt.value }}</label>
                  <input type="radio" :name="key" v-model="response[activePlugin.optionName][key]" :value="opt.value" id="'radio-'+key+'-'+opt.value">
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button class="btn-primary btn-sm btn pull-right" v-if="Object.keys(activePlugin).length" @click="saveOptions">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import seoPressPro from './Plugins/seopresspro.json'
import seoPress from './Plugins/seopress.json'
import wpScript from './Plugins/wpscript.json'
import response from './Plugins/response.json'
import plugins from './Plugins/Plugins.json'
export default {
  name: 'Plugins',
  data () {
    return {
      activePlugin: {},
      plugins: {
        seoPressPro: {
          name: 'SeoPress Pro',
          optionName: 'seopress_pro_option_name',
          setup: seoPressPro
        },
        wpScript: {
          name: 'WP Script',
          optionName: 'wpst-options',
          setup: wpScript
        },
        seoPress: {
          name: 'SeoPress',
          optionName: 'seopress_titles_option_name',
          setup: seoPress
        }
      },
      newPlugins: plugins,
      response: response
    }
  },
  props: ['site'],
  mounted () {
    this.loadOptions()
  },
  methods: {
    showPlugin (name) {
      this.activePlugin = this.plugins[name]
    },
    saveOptions () {
      console.log(this.response[this.activePlugin.optionName])
      axios.patch('/am/plugin/site/' + this.site.url + '/plugin/options', {
        data: this.response[this.activePlugin.optionName],
        option: this.activePlugin.optionName
      })
        .then(r => {
          this.$toastr.success('Options updated!', 'Good stuff!')
          this.loadOptions()
        })
    },
    loadOptions () {
      axios.get('/am/plugin/site/' + this.site.url + '/plugin/options?options=wpst-options,seopress_pro_option_name,seopress_option_name,seopress_titles_option_name')
        .then(r => {
          this.response = r.data
        })
    }
  }
}
</script>

<style scoped>
.wp-radio label {
  margin-right: 5px;
}
.wp-radio li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Manager/Site/Plugins.vue